import http from "../common/http";
import {getUUID} from "../../sdk/common/utils";
import softInfo from "../../gevt";
import hdapi from "../../../common/hdapi";
import axios from "axios";
import {config} from "..";
/**
 * 获取服务器时间戳(秒)
 * @returns {Promise<number>}
 */
export function getutctime() {
	return http.get("/api/v4/getutctime").then((x) => x.utctime);
}

/**
 * 获取查询标识
 * @returns {Promise<string>}
 */
export function wechatguid() {
	return http.post("/api/v4/wechatguid").then((x) => x.logintag);
}

/**
 * QQ微信查询登录结果
 * http://115.159.44.133:9108/apidoc/wechatguid.html
 * @param {string} logintag 待查询的标识码
 * @param {boolean} showvip 是否显示vip信息，取值范围 0（不显示）或1(显示)，默认为0
 * @returns {Promise<UserInfo>}
 */
export function wechatstate(logintag, showvip) {
	if (showvip) showvip = 1;
	else showvip = undefined;
	return http.post("/api/v4/wechatstate", {logintag, showvip}).then((x) => x.userinfo);
}

/**
 * 获取短信验证码
 * @param {object} data
 * @param {string} data.verifytype	验证类型：register-注册,forgetpwd-找回密码,quicklogin-快捷登录,bindaccount-绑定帐号
 * @param {string} data.account	帐号,国内手机不添加区号；国外手机号：国家区号(去除前置的0)-手机号，其它间隔符为 英文"-"如美国号码格式为：1-8782031060
 * @param {string} [data.usertoken]	token；只有绑定帐号时需要
 * @param {string} [data.bindaccount] (11)	待绑定的手机号
 * @param {string} [data.officialwebsite]	官网网址；只有发送邮件时选填；
 * @param {string} [data.mac]	MAC地地址，示例：C0:77:36:2E:E2:79
 * @param {string} [data.apptype]	设备类型，设备类型举例：1、PC 2、MOBILE
 * @param {string} [data.appsource]	操作来源举例：1、PC 2、H5 3、App
 * @param {int} [data.accounttype]	帐号类型；海外手机号必须赋值 1，其它默认0或不填，后续帐号类型标识待定；如果为绑定手机号，请填写待绑定手机号是否是海外手机号； 20201230 当帐号为邮箱且此字段赋值 1 时，邮箱内容为指定语言对应的内容
 */
export function safsmsverify(data) {
	return http.post("/api/v4/safsmsverify", data);
}

/**
 * 带着验证码和手机号去登录
 * @param {object} data
 * @param {string} data.account 手机号码,国内手机不添加区号；国外手机号：国家区号(去除前置的0)-手机号，其它间隔符为 英文"-"如美国号码格式为：1-8782031060
 * @param {string} data.smscode (4)	短信或邮件校验码
 * @param {string} [data.imgcode] (1-10)	图形验证码；saf不需要填写；
 * @param {int} [data.showvip] 	是否显示vip信息，取值范围 0（不显示）或1(显示)，默认为0
 * @param {int} [data.accounttype] 	帐号类型；海外手机号必须赋值 1，其它默认0或不填，后续帐号类型标识待定；
 * @returns {Promise<UserInfo>}
 */
export function safloginquick(data) {
	return http.post("/api/v4/safloginquick", data).then((x) => x.userinfo);
}

/**
 * 获取图形验证码 (base64)
 * @param {object} data
 * @param {int} {data.width}	图片宽度:10-300	是
 * @param {int} {data.height}	图片高度：10-100	是
 * @param {int} {data.length}	字符数量：1-10	是
 * @param {int} {data.fontsize}	字符大小(px)：9-100	是
 * @returns {Promise<string>}
 */
export function imgverify(data) {
	return http.post("/api/v4/imgverify", data).then((x) => x.message);
}

/**
 * 带图片的获取短信验证
 * @param {object} data
 * @param	{string} data.verifytype	验证类型：register-注册,forgetpwd-找回密码,quicklogin-快捷登录,bindaccount-绑定帐号
 * @param	{string} data.account	帐号,国内手机不添加区号；国外手机号：国家区号(去除前置的0)-手机号，其它间隔符为 英文"-"如美国号码格式为：1-8782031060
 * @param	{string} [data.usertoken]	token；只有绑定帐号时需要
 * @param	{string} [data.bindaccount] (11)	待绑定的手机号
 * @param	{string} [data.officialwebsite]	官网网址；只有发送邮件时选填；
 * @param	{string} [data.mac]	MAC地地址，示例：C0:77:36:2E:E2:79
 * @param	{string} [data.apptype]	设备类型，设备类型举例：1、PC 2、MOBILE
 * @param	{string} [data.appsource]	操作来源举例：1、PC 2、H5 3、App
 * @param	{int} [data.accounttype]	帐号类型；海外手机号必须赋值 1，其它默认0或不填，后续帐号类型标识待定；如果为绑定手机号，请填写待绑定手机号是否是海外手机号； 20201230 当帐号为邮箱且此字段赋值 1 时，邮箱内容为指定语言对应的内容
 */
export function smsverify(data) {
	return http.post("/api/v4/smsverify", data);
}

/**
 * 带图片的登录验证
 * @param {object} data
 * @param {string} data.account	手机号码,国内手机不添加区号；国外手机号：国家区号(去除前置的0)-手机号，其它间隔符为 英文"-"如美国号码格式为：1-8782031060
 * @param {string} data.imgcode(1-10)	图形验证码
 * @param {string} data.smscode(4)	短信或邮件校验码
 * @param {int} [data.showvip]	是否显示vip信息，取值范围 0（不显示）或1(显示)，默认为0
 * @param {int} [data.accounttype]	帐号类型；海外手机号必须赋值 1，其它默认0或不填，后续帐号类型标识待定；
 */
export function loginquick(data) {
	return http.post("/api/v4/loginquick", data).then((x) => x.userinfo);
}

/**
 * 二码合一支付,请求获取对应的支付二维码
 * @param {object} data
 * @param {string} data.deviceid(32)	客户端电脑唯一识别码，32位小写；
 * @param {string} data.deviceos	客户端设备信息： win7/8/10 或 andriod8.1 或 浏览器信息 或 其它
 * @param {long} data.timestamp	Uinx 时间戳；获取服务器时间戳
 * @param {string} data.account	帐号,国内手机不添加区号；国外手机号：国家区号(去除前置的0)-手机号，其它间隔符为 英文"-"如美国号码格式为：1-8782031060
 * @param {string} data.datasign(32)	签名参数，请参考签名生成规则；
 * @param {string} data.productinfo	通过接口 /api/v4/PaySubscribeParm 获取
 * @param {string} [data.clientip]	客户端IP地址 （服务器转发时必填，其它直连接口的不需要填写）
 * @param {int} [data.accounttype]	帐号类型；海外手机号必须赋值 1，其它默认0或不填，后续帐号类型标识待定；
 * @param {int} [data.width]	默认100，取值范围（60-500）
 * @param {int} [data.iflogo]	是否在二维码中显示互盾logo；默认1（显示），取值范围：0，1
 * @param {string} [data.noticeurl]	支付宝的通知地址（支付宝必填）,校验的正则为：[a-zA-Z0-9_\.\-\|\/\:\?]{1,200}
 * @param {string} [data.memprofile]	附加会员信息，格式json；如预约等购买时填写；
 * @param {string} [data.orderno] (15-32)	如果在其它应用中有生成订单号，填写
 * @param {int} [data.sellerversion]	支付收款版本 默认为1 类型：int
 * @param {int} [data.servicetype]	支付服务类型 1正常支付 2预约服务(涉及客服) 默认为1
 * @param {int} [data.accounttype]	帐号类型；海外手机号必须赋值 1，其它默认0或不填，后续帐号类型标识待定；
 * @param {int} [data.isqrcode]	20210325添加；
	是否在产生二维码回执；默认1（显示），取值范围：0，1
	当取值为0时，回执为 url的base64编码，并对base64做了混淆；解混淆的C#代码参考
	客户端使用要先解密，然后 解base64,然后再生成二维码；
 * @returns {Promise<{orderno: string;qrcode: string}>}
 */
export function paymerge(data) {
	if (data.deviceos == null) data.deviceos = navigator.userAgent;
	return http.post("/api/v4/paymerge", data);
}

/**
 * 查询支付状态接口
 * @param {object} data
 * @param {string} data.account	帐号
 * @param {string} data.orderno	订单号
 * @param {int} [data.packageid]	套餐ID
 * @returns {Promise<boolean>} true:支付成功 false:待支付
 */
export function payorderstatedetails(data) {
	return http
		.post("/api/v4/payorderstatedetails", data, {allcode: true})
		.then((x) => (x.code == 10000 ? true : x.code == 20000 ? false : Promise.reject(x)));
}

/**
 * 获取基础信息
 * @param {object} data
 * @param {string} data.account	帐号(username)
 * @param {string} data.token	token
 * @param {int} [data.accounttype]	accounttype:帐号类型（1手机号 2邮箱 3微信 4qq 5机器码 6百度）
 */
export function membasicinfo(data) {
	return http.post("/api/v4/memprofile", data).then((x) => x.userinfo);
}

/**
 * 获取用户订单信息
 * @param {object} data
 * @param {string} data.account	帐号(username)
 * @param {string} data.usertoken	usertoken
 * @param {int} [data.querytype]	querytype:帐号类型（0全部 1未支付 2已支付 3已退款，默认2）
 * @param {int} [data.ifname]	ifname:是否根据购买的产品名称查询：0否 2(按产品ID)，默认0
 */
export function memorder(data) {
	return http
		.post("/api/v4/memorder", data)
		.then((x) => (x.code == 10000 ? x.orderlist : Promise.reject(x)));
}

export async function registerOCPC(userInfo, price) {
	let userID = userInfo ? userInfo.uid : "";
	let hd_price = price ? price : "";
	const isWins =
		navigator.platform == "Win32" ||
		navigator.platform == "Windows" ||
		navigator.platform == "Win16" ||
		navigator.platform == "WinCE";
	const DEVICE_TYPE = isWins ? "pc" : "mac";
	let platform = DEVICE_TYPE === "pc" ? "Windows" : "Mac";
	// appStore = DEVICE_TYPE === "pc" ? "xunjieimageconverter.exe" : "xunjieimageconverter.dmg",
	// const ocpcDict = {
	// 	baidu: "statistics.json",
	// 	// '360': 'statistics_360.json'
	// };
	let pageUrl = window.location.href;
	console.log("pageUrl", pageUrl);
	let oppcHost = "https://kuaishouapi.yiyongcad.com";
	if (pageUrl.indexOf("yasuo-pc.alitest.yiyongcad.com") > -1) {
		oppcHost = "http://kuaishou.test2.huduntech.com"; //测试服ocpc
	} else {
		oppcHost = "https://kuaishouapi.yiyongcad.com"; //正式服ocpc
	}
	let params = {
		hd_app_platform: 4,
		hudun_uuid: getUUID(),
		hd_event_type: 1,
		hd_app_id: "CompressMagician",
		// hd_app_store: appStore,
		hd_app_version: softInfo.version,
		hd_user_id: userID,
		os: platform,
		os_version: hdapi.platform_version,
		// mac1: "",
		hd_price: hd_price,
	};
	console.log("请求参数", JSON.stringify(params));
	let resState = await http.post(`${oppcHost}/baidu/event`, JSON.stringify(params)).catch((err) => {
		if (err.code == 0) {
			console.log("激活成功");
			return true;
		} else {
			console.log("激活失败");
			return false;
		}
	});
	return resState;
}

// 在线转换接口

/**
 * 上传接口获取权限
 * @param data
 *  filecount
 *  filename
 *  isshare
 *  limitsize
 *  machineid
 *  softname
 *  softversion
 *  tasktype
 *  timestamp
 *  account
 *  usertoken
 *  pagerange    string    转换的页码范围，根据具体的转换功能取值    否
 *  picturequality    string    图片质量、压缩类型    否
 *  filesequence    string    文件顺序    否
 *  validpagescount    int    限制最大转换多少页    否
 *  picturetoonepdf    string    图片转pdf 选项：yes\no    否
 *  iconsize    int    图片转icon时的宽度    否
 *  pictureforecolor    string    图片前景色    否
 *  picturebackcolor    string    图片背景色    否
 *  fileversion    string    多功能参数    否
 *  fanyi_from    string    文件的源语言    否
 *  fanyi_to    string    文件的目标语言    否
 *  outputfileextension    string    转换后输出类型后缀，比如 txt    否
 *  filesrotate    string    文件的旋转角度，取值0-3,1表示顺时针90度；多件文件时，请上传0,0,0,0    否
 *  fileopenpwd    List<string>    不参与签名件的打开密码，有值时，长度与文件数量一致；    否
 *  filenewpwd    string    新密码    否
 *  watermarktext    string    水印内容    否
 *  parainfo    string    多功能参数    否
 *  textold    List<string>    不参与签名多功能参数    否
 *  textnew    List<string>    不参与签名多功能参数    否
 *  hdaccount    string(32)    鉴权帐号，二次封装时会使用，必须要与hdtoken同时出现    否
 *  hdtoken    string(32)    鉴权帐号的token，二次封装时会使用    否
 * @returns {*|Promise|Promise<*>}
 * {
 *     tasktag
 *     timestamp
 *     tasktoken
 * }
 */
export function uploadVerify(data, file) {
	if (file.isStopCompress) return Promise.reject("stop");
	return http.post("/api/v4/uploadpar", data).then(
		(res) => {
			if (res.code == 10000) return res;
		},
		(err) => {
			if (err.code == 10031) {
				// clearInterval(file.upload_time);
				// console.log("10031");
				return "ExceedeTimes";
			} else return Promise.reject(err);
		}
	);
}

// 上传文件接口
export function upload(file, data) {
	console.log(file.chunk);
	let query =
		"?tasktag=" +
		data.tasktag +
		"&timestamp=" +
		data.timestamp +
		"&tasktoken=" +
		data.tasktoken +
		"&fileindex=" +
		file.fileIndex +
		"&chunks=" +
		file.chunks +
		"&chunk=" +
		file.index;
	return axios.post(config.apiDomain + "/api/v4/uploadfile" + query, file.chunk);
}

export async function uploadAll(file, _data, i) {
	if (file.isStopCompress) return Promise.reject("stop");
	let a = await upload(file.chunksList[i], _data).then((res) => {
		console.log(res, "上传成功返回res");
		if (res.data.code == 11000) {
			return uploadAll(file, _data, ++i);
		}
		if (res.data.code == 10000) return "上传结束";
	});
	return a;
}

export async function checkIsCompressOver(file) {
	if (file.isStopCompress) return Promise.reject("stop");
	file.checkTime = 1500;
	file.checkTimes = 1;
	file.checkAllTime = 1500;
	const p = new Promise((resolve, reject) => {
		async function checkYsOver() {
			if (file.isStopCompress) {
				clearInterval(file.upload_time);
				return Promise.reject("stop");
			}
			if (file.checkTimes > 200 || file.checkAllTime > 20 * 60 * 1000) {
				clearInterval(file.upload_time);
				return Promise.reject("超出请求时间");
			}

			let a = await getTaskStatus(file).catch((err) => {
				return err;
			});
			console.log("a", a);
			// console.log("getTaskStatus", a);
			if (a.code == 10000) {
				clearInterval(file.upload_time);
				if (file.isStopCompress) return Promise.reject("stop");
				file.onlineCompressStep = 4;
				let b = await getTaskDownloadUrl(file);
				if (b.code == 10000) {
					file.onlineCompressStep = 5;
					file.downloadurl = b.downurl;
					let e = await axios({
						method: "get",
						url: file.downloadurl,
						responseType: "arraybuffer",
					}).then((res) => {
						return res;
					});
					if (file.isStopCompress) return Promise.reject("stop");
					// console.log("e", e);
					await hdapi.writeFile(file.outpath, Buffer.from(e.data));
					file.onlineCompressStep = 6;
					resolve(b);
				}
			} else if (a.code == 52500) {
				clearInterval(file.upload_time);
				reject(a);
			} else {
				file.checkTimes += 1;
				if (file.checkTimes < 5) {
					clearInterval(file.upload_time);
					file.checkTime = 1500;
					file.checkAllTime += 1500;
					file.upload_time = setInterval(checkYsOver, file.checkTime);
				} else if (5 <= file.checkTimes && file.checkTimes < 10) {
					clearInterval(file.upload_time);
					file.checkTime = 2000;
					file.checkAllTime += 2000;
					file.upload_time = setInterval(checkYsOver, file.checkTime);
				} else {
					clearInterval(file.upload_time);
					file.checkTime = 3000;
					file.checkAllTime += 3000;
					file.upload_time = setInterval(checkYsOver, file.checkTime);
				}
			}
		}
		file.upload_time = setInterval(checkYsOver, file.checkTime);
	});
	return await p;
}

// 查询文件转换是否结束
/**
 * 获取任务状态
 * @param data
 * @returns {*|Promise|Promise<*>}
 */
export function getTaskStatus(file) {
	let data = {};
	data.tasktag = file.upload_data.tasktag;
	if (window.store.VIPlevel) {
		data.account = window.store.local.userLoginData.username;
		data.usertoken = window.store.local.userLoginData.usertoken;
	}
	return http.post("/api/v4/taskstate", data);
}

// 获取下载地址
export function getTaskDownloadUrl(file) {
	let data = {};
	data.tasktag = file.upload_data.tasktag;
	if (window.store.VIPlevel) {
		data.account = window.store.local.userLoginData.username;
		data.usertoken = window.store.local.userLoginData.usertoken;
	}
	return http.post("/api/v4/taskdown", data);
}

// 支付宝付款页面
export function payorder(data) {
	if (data.deviceos == null) data.deviceos = navigator.userAgent;
	if (data.devicetype == null) data.devicetype = "pc";
	if (data.softname == null) data.softname = "CompressMagician";
	if (data.softversion == null) data.softversion = window.$softInfo.version;
	return http.post("/api/v4/payorder", data);
}
